import { render, staticRenderFns } from "./profitStatement.vue?vue&type=template&id=0996f4e4&scoped=true"
import script from "./profitStatement.vue?vue&type=script&lang=js"
export * from "./profitStatement.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/myGuZhi.css?vue&type=style&index=0&id=0996f4e4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0996f4e4",
  null
  
)

export default component.exports